<main class="container">
  <h1 class="title text-center">Instituições ofertantes</h1>
  <app-instituicao-busca [instituicoes]="instituicoes" [componenteRef]="componenteRef"
    (inputEvent)="recebeuInput($event)"></app-instituicao-busca>
  <section class="response">
    <p *ngIf="totalResultados" class="text-center results">
      Total de resultados encontrados {{ totalResultados }}
    </p>
    <p *ngIf="!totalResultados || (!totalResultados && realizouBusca)" class="text-center results">
      Desculpe, não encontramos nenhum resultado compatível com sua busca.
    </p>

    <ul>
      <li class="card bg-color-white contrast-border" *ngFor="let institicao of pagedItems">
        <app-card-instituicao [titulo]=[institicao.nome] [nome]="institicao.nome" [endereco]="institicao.endereco"
          [telefone]="institicao.telefone" [email]="institicao.email" [tipo]="institicao.tipo"
          [homePage]="institicao.site"></app-card-instituicao>
      </li>
      <hr class="hr-line bg-color-dark-grey" />
    </ul>
    <!-- pager -->
    <ul *ngIf="pager.pages && pager.pages.length" class="paginacao">
      <li [class.disabled]="pager.currentPage === 1">
        <a (click)="setPage(1)" class="arrows" title="Ir para primeira pagina">&laquo;</a>
      </li>
      <li [class.disabled]="pager.currentPage === 1">
        <a (click)="setPage(pager.currentPage - 1)" class="arrows" title="Ir para pagina anterior">&lsaquo;</a>
      </li>
      <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}" class="pagination-item">
        <a (click)="setPage(page)">{{page}}</a>
      </li>
      <li [class.disabled]="pager.currentPage === pager.totalPages">
        <a (click)="setPage(pager.currentPage + 1)" class="arrows" title="Ir para a proxima página">&rsaquo;</a>
      </li>
      <li [class.disabled]="pager.currentPage === pager.totalPages">
        <a (click)="setPage(pager.totalPages)" class="arrows" title="Ir para a última página">&raquo;</a>
      </li>
    </ul>


  </section>
</main>